"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
import * as d from "react";
import { cn as f } from "./index15.js";
const p = d.forwardRef(
  ({ className: a, label: s, value: r, onValueChange: n, ...l }, c) => /* @__PURE__ */ o("div", { className: f("flex items-center gap-3", a), children: [
    /* @__PURE__ */ o("div", { className: "relative h-9 w-9 shrink-0 overflow-hidden rounded border border-border", children: [
      /* @__PURE__ */ e(
        "input",
        {
          ref: c,
          type: "color",
          value: r,
          onChange: (t) => n(t.target.value),
          className: "absolute -inset-1 h-12 w-12 cursor-pointer border-0 p-0 opacity-0",
          ...l
        }
      ),
      /* @__PURE__ */ e("div", { className: "h-full w-full rounded", style: { backgroundColor: r } })
    ] }),
    /* @__PURE__ */ o("div", { className: "flex-1 space-y-0.5", children: [
      s && /* @__PURE__ */ e("p", { className: "text-xs font-medium text-text", children: s }),
      /* @__PURE__ */ e(
        "input",
        {
          type: "text",
          value: r,
          onChange: (t) => {
            const i = t.target.value;
            /^#[0-9a-fA-F]{0,6}$/.test(i) && n(i);
          },
          className: "h-7 w-28 rounded border border-border bg-surface px-2 font-mono text-xs text-text focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-accent",
          spellCheck: !1
        }
      )
    ] })
  ] })
);
p.displayName = "ColorInput";
export {
  p as ColorInput
};
//# sourceMappingURL=index2.js.map
